import { MapPin, Mail, ExternalLink } from 'lucide-react'

const productLinks = [
  { label: 'Spotto App', href: 'https://spotto.pl', external: true },
  {
    label: 'Google Play',
    href: 'https://play.google.com/store/apps/details?id=pl.spotto.mobile',
    external: true,
  },
  { label: 'App Store', href: 'https://apps.apple.com/app/spotto', external: true },
]

const companyLinks = [
  { label: 'O nas', href: '#about' },
  { label: 'Produkt', href: '#product' },
  { label: 'Funkcje', href: '#features' },
  { label: 'Kontakt', href: '#contact' },
]

export default function Footer() {
  return (
    <footer id="contact" className="relative border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Company info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-9 h-9 rounded-lg bg-brand-600 flex items-center justify-center text-white font-extrabold text-sm">
                SL
              </div>
              <span className="text-white font-bold text-lg">Solid Labs PSA</span>
            </div>
            <p className="text-zinc-500 text-sm leading-relaxed max-w-sm mb-6">
              Krakowska firma technologiczna tworzaca nowoczesne platformy
              cyfrowe dla branzy sportowej. Tworca aplikacji Spotto.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-sm text-zinc-400">
                <MapPin size={16} className="text-zinc-600 shrink-0" />
                Mogilska 43, 31-545 Krakow
              </div>
              <a
                href="mailto:hello@solidlabs.site"
                className="flex items-center gap-3 text-sm text-zinc-400 hover:text-brand-400 transition-colors"
              >
                <Mail size={16} className="text-zinc-600 shrink-0" />
                hello@solidlabs.site
              </a>
            </div>
          </div>

          {/* Product links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Produkt</h4>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target={link.external ? '_blank' : undefined}
                    rel={link.external ? 'noopener noreferrer' : undefined}
                    className="flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-300 transition-colors"
                  >
                    {link.label}
                    {link.external && <ExternalLink size={12} />}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-5">Firma</h4>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-zinc-500 hover:text-zinc-300 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            &copy; {new Date().getFullYear()} Solid Labs PSA. Wszystkie prawa
            zastrzezone.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-xs text-zinc-600 hover:text-zinc-400 transition-colors"
            >
              Polityka prywatnosci
            </a>
            <a
              href="#"
              className="text-xs text-zinc-600 hover:text-zinc-400 transition-colors"
            >
              Regulamin
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
